import React, { ReactNode } from 'react';
import { LabeledInput, SectionTitle } from '../fields';

import { DrawRuleProps } from 'modules/tournaments/ui/components/form-parts/rules/types';

interface ExtendedDrawRuleProps extends DrawRuleProps {
  children?: ReactNode;
}

const DrawBase: React.FC<ExtendedDrawRuleProps> = ({ sportType = 'general', children }) => {
  return (
    <>
      <SectionTitle title="Ничья" icon="⚔️" tooltip="Настройка очков за ничью." />

      <LabeledInput
        name="settings.drawScore"
        placeholder="0 очков"
        label=""
        containerClassName="mb-4"
        inputContainerClassName="min-w-[120px]"
        alignRight={false}
        tooltip="Очки за ничью в основное время (в большинстве турниров за ничью дают 1 очко)."
        tooltipProps={{ position: 'input-right' }}
      />

      {/* Место для дополнительных полей */}
      {children}
    </>
  );
};

export default DrawBase;
